/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Disableloginscreen2Inputs */

const en_entity_disableloginscreen2 = /** @type {(inputs: Entity_Disableloginscreen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable Login Screen`)
};

const de_entity_disableloginscreen2 = /** @type {(inputs: Entity_Disableloginscreen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login-Screen deaktivieren`)
};

/**
* | output |
* | --- |
* | "Disable Login Screen" |
*
* @param {Entity_Disableloginscreen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_disableloginscreen2 = /** @type {((inputs?: Entity_Disableloginscreen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Disableloginscreen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_disableloginscreen2(inputs)
	return de_entity_disableloginscreen2(inputs)
});
export { entity_disableloginscreen2 as "entity_disableLoginScreen" }